import { Injectable } from '@angular/core';
import { UserProfileDto, UserProfileService } from '../proxy/users';
import { tap } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserCacheService {

  private _user: UserProfileDto | null = null;

  constructor(
    private userProfileService: UserProfileService,
    private oAuthService: OAuthService,
  ) { }

  load(): Promise<void> {
    if (!this.oAuthService.hasValidAccessToken()) {
      console.info('[Auth] Skipping current-user bootstrap request because no access token exists yet');
      return Promise.resolve();
    }

    return this.userProfileService.getCurrentUser().pipe(
      tap(profile => {
        this._user = profile;
        console.log('[CurrentUserCacheService] Loaded user profile:', profile);
      })
    ).toPromise().then(() => { });
  }

  get user(): UserProfileDto | null {
    return this._user;
  }
}
